import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-login-logo",
	templateUrl: "./login-logo.component.html",
	styleUrls: ["./login-logo.component.css"],
})
export class LoginLogoComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////

	@Input() DistrictInfoLoading: boolean = false;

	@Input() ShowDistrictName: boolean = false;
	@Input() DistrictDisplayName: string = "";
	@Input() DistrictVersionNumber: string = "";

	@Input() VersionChecked: boolean = false;
	@Input() VersionMatch: boolean = false;
	@Input() CAASS_VERSION: string = "";

	@Input() errorMessage: string = "";
	////////////////////////////////////////////////////////////////////
}
